module.exports = __webpack_public_path__ + "static/media/membership.72ab993f.jpg";